export const white = '#FFFFFF';
export const black = '#000000';

export const gray = {
  50: '#f9f9f9',
  100: '#f4f4f4',
  200: '#eeeeee',
  300: '#e6e6e6',
  400: '#d2d2d2',
  500: '#aaaaaa',
  600: '#515457',
  700: '#363a3d',
  800: '#222222',
  900: '#1a1c1f',
};
